namespace TabAurous {
    export interface RetailRequest extends Serenity.ListRequest {
        RewardCode?: string;
        ProductTypeId?: number;
        CompanyId?: number;
        IsDisabled?: boolean;
        IsApproved?: boolean;
        FromDate?: string;
        ToDate?: string;
    }
}
